:host {
  display: block;
}

.s-rating-stars-small {
  line-height: 12px;
}
.s-filters-radio{
  background-image: none !important;
}